import { useCallback, useEffect } from 'react';

import { toCSV } from 'utils/clickme';
import { BILLING_FUNNEL_HEADERS, BILLING_FUNNEL_TOTAL } from 'utils/constants/admin';
import { FILE_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import BillingFunnelTable from 'components/Admin/Reports/BillingFunnelReport/BillingFunnelTable';
import fetchBillingFunnel from 'components/Admin/Reports/BillingFunnelReport/fetchBillingFunnel';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { setBillingFunnelDates } from 'store/models/billingFunnel';
import { useDispatch, useSelector } from 'store/utils';

const BillingFunnelReport = () => {
    const { from, to, billingFunnelData, billingFunnelTotal, isLoad } = useSelector((state) => state.billingFunnel);
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClickCSV = useCallback(() => {
        const fileName = `billing_funnel_${formatDate(from, FILE_DATE_FORMAT)}_${formatDate(to, FILE_DATE_FORMAT)}.csv`;
        toCSV(
            fileName,
            [{ accountId: BILLING_FUNNEL_TOTAL, ...billingFunnelTotal }, ...billingFunnelData],
            BILLING_FUNNEL_HEADERS,
            []
        );
    }, [billingFunnelData, billingFunnelTotal, from, to]);

    useEffect(() => {
        dispatch(fetchBillingFunnel());
    }, [dispatch]);

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.billingFunnel')}
            filter={
                <InputWithMultiDatePicker
                    action={(from, to) => dispatch(setBillingFunnelDates({ from, to }))}
                    from={from}
                    to={to}
                />
            }
            content={<BillingFunnelTable />}
            isLoadContent={isLoad}
            onClickSearch={() => dispatch(fetchBillingFunnel())}
            onClickCSV={onClickCSV}
        />
    );
};

export default BillingFunnelReport;
